<template lang="html" src="./HealthPlanTransfer.html">

</template>
<script>
import mixins from "@/Mixins"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      customerPlans: [],
      patients: [],
      idPatient: 0,
      pageTable: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchCustomers: "",
      selectedPatient: {},
      selectedHealthPlan: null,
      selectedTransferType: null,
      showHealthPlanTransferPopup: false,
      newHealthPlan: null,
      previousHealthPlan: null,
      newTerm: "",
      currentTerm: "",
      newValue: 0,
      currentValue: 0,
      isLoadingHealthPlanTransfer: false,
    };
  },
  computed: {
    isTypeTransferDisabled () {
      const checkEqual = this.selectedHealthPlan === this.previousHealthPlan

      return !this.selectedHealthPlan || checkEqual
    },
    isButtonTransferDisabled () {
      return !this.selectedTransferType || this.isTypeTransferDisabled
    },
    isOnlyImmediate () {
      return !this.isTypeTransferDisabled && !this.selectedPatient.nextBilling
    },
    nextBillingDate () {
      if (this.selectedTransferType === 'SCHEDULED') {
        return this.selectedPatient.nextBilling
          ? this.selectedPatient.nextBilling.split("-").reverse().join("/")
          : null
      }
      return null
    }
  },
  created () {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  async mounted () {
    this.bearer = await this.$session.get("bearerDefault")
    await this.$session.set("bearerDefault", this.bearer)
    await this.getPlans()
    await this.getCustomers()
  },
  destroyed () {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    getPlans () {
      this.axios.get(
        `${this.$store.state.filooServer}customerplan/actives`,
        { headers: { Authorization: this.bearer }},
      )
        .then(({ data }) => (this.customerPlans = data))
    },
    handleResize () {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
    },
    getCustomers () {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "consultant/patients?page=" +
          page + "&search=" + vm.searchCustomers +
          "&size=10&sort=name,asc",
          {
            headers: { Authorization: this.bearer }
          }
        )
        .then((response) => {
          if (response.status === 200) {
            vm.patients = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.fillPatients();
          }
        }).finally(() => {
          vm.$vs.loading.close();
        });
    },
    changeSearchCustomers () {
      const vm = this;
      vm.currentx = 1;
      vm.$vs.loading();
      vm.getCustomers();
    },
    fillPatients () {
      const fields = ["name", "email", 'phone', "customerPlanName"]

      this.patients.forEach((p) => {
        fields.forEach((field) => {
          p[field] = p[field] ? p[field] : "Sem registro"

          if (field === "phone") {
            p[field] = this.maskCelPhone(p[field])
          }
        })
      })
    },
    async healthPlanTransfer(patient) {
      if (this.isLoadingHealthPlanTransfer) return; 
      this.isLoadingHealthPlanTransfer = true;
      this.$vs.loading();
      this.selectedPatient = patient
      
      if (patient.customerPlanId) {
        const plan = this.customerPlans.find((p) => p.id === patient.customerPlanId)
        this.selectedHealthPlan = plan
        this.previousHealthPlan = plan
        this.currentValue = this.maskMoney(plan.planValue)
        this.newValue = this.maskMoney(plan.planValue)
      }

      try {
        const { data } = await this.axios.get(
          `${this.$store.state.filooServer}consultant/patient/simplified/billingDate`,
          {
            headers: { Authorization: this.bearer },
            params: { patientId: patient.id }
          }
        )
        this.selectedPatient.nextBilling = data && data.nextBilling ? data.nextBilling : null
      } catch (error) {
        this.selectedPatient.nextBilling = null
      } finally {
        this.$vs.loading.close(); 
        this.isLoadingHealthPlanTransfer = false;
        this.showHealthPlanTransferPopup = true
      }

    },
    async updateHealthPlan () {
      this.$vs.loading()

      const payload = {
        patientId: this.selectedPatient.id,
        planId: this.newHealthPlan.id,
        typeOfTransfer: this.selectedTransferType,
        billingDate: this.selectedPatient.nextBilling
      }

      try {
       

        const response = await this.axios.post(
          `${this.$store.state.filooServer}patient/health-plan-transfer`,
          payload,
          { headers: { Authorization: this.bearer } }
        )

        if (response.status === 200) {
          this.$vs.notify({
            title: "Sucesso!",
            text: `O plano do paciente ${this.selectedPatient.name} foi alterado com sucesso!`,
            color: "success",
            icon: "verified_user",
            position: "top-right",
          })
          this.clearTransfer()
          this.getCustomers()
        } else {
          this.showError()
        }
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message

        if (message === 'exception.badrequest.cpf.cnpj') {
          this.showErrorCpf()
        } else if (message === 'exception.badrequest.plan.identifier') {
          this.showErrorPlanIdentifier()
        } else {
          this.showError()
        }
      } finally {
        this.$vs.loading.close()
      }
    },
    showErrorPlanIdentifier () {
      const vm = this;
      vm.$vs.notify({
        title: "Erro!",
        text: `O plano selecionado não foi identificado no IUGU`,
        color: "danger",
        icon: "error",
        position: "top-right",
      });
    },
    showErrorCpf () {
      const vm = this;
      vm.$vs.notify({
        title: "Erro!",
        text: `Confira se o CPF do usuário é válido e tente novamente`,
        color: "danger",
        icon: "error",
        position: "top-right",
      });
    },
    showError () {
      const vm = this;
      vm.$vs.notify({
        title: "Erro!",
        text: `Aconteceu um erro durante o processo de alteração`,
        color: "danger",
        icon: "error",
        position: "top-right",
      });
    },
    clearTransfer () {
      this.showHealthPlanTransferPopup = false
      this.selectedHealthPlan = null
      this.newHealthPlan = null
      this.selectedPatient = {}
      this.selectedTransferType = null
    }
  },
  watch: {
    selectedHealthPlan (newVal) {
      if (newVal) {
        this.newHealthPlan = newVal
        this.newValue = this.maskMoney(newVal.planValue)
        if (!this.selectedPatient.nextBilling && !this.isTypeTransferDisabled) {
          this.selectedTransferType = 'IMMEDIATE'
        }
      }
    },
    currentx () {
      this.getCustomers()
    },
  },
};
</script>
<style lang="scss"  src="./HealthPlanTransfer.scss" scoped />
